export default __webpack_public_path__ + "images/85a8a42c05277f9201728e80d9d2833d.png";